const FullScreenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M3.11328 9.21045V3.21045H9.11328M15.1133 3.21045H21.1133V9.21045M3.11328 15.2104V21.2104H9.11328M21.1133 15.2104V21.2104H15.1133"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export default FullScreenIcon;
